<div class="banner" role="status" aria-live="polite">
  {{ message }}
</div>
